import './styles.scss';

import React from 'react';
import PropTypes from 'prop-types';
import ReactTouchEvents from "react-touch-events";

export default class PhotoSlider extends React.Component {
    static propTypes = {
        children: PropTypes.any,
        isEnabled: PropTypes.bool.isRequired,
        onPrevPhoto: PropTypes.func.isRequired,
        onNextPhoto: PropTypes.func.isRequired,
        onClose: PropTypes.func.isRequired,
        prevPhoto: PropTypes.shape({

        }),
        nextPhoto: PropTypes.shape({

        })
    };
    static defaultProps = {
        prevPhoto: null,
        nextPhoto: null
    }

    constructor(props) {
        super(props);
    }

    handleSwipe = direction => {
        switch (direction) {
            case "left":
                if (this.props.nextPhoto) this.props.onNextPhoto();
                break;
            case "right":
                if (this.props.prevPhoto) this.props.onPrevPhoto();
                break;
        }
    }

    render() {
        const { children, isEnabled, prevPhoto, nextPhoto } = this.props;
        if (!isEnabled) return (children);

        return (
            <ReactTouchEvents onSwipe={this.handleSwipe}>
                <div className="photo-slider-component">
                    <a className="control-button close-button" onClick={this.props.onClose}>
                        <i className="fa fa-times"></i>
                    </a>
                    {!prevPhoto ? null :
                        <a className="control-button photo-controls previous" onClick={this.props.onPrevPhoto}>
                            <i className="fa fa-chevron-left"></i>
                        </a>
                    }
                    {children}
                    {!nextPhoto ? null :
                        <a className="control-button photo-controls next" onClick={this.props.onNextPhoto}>
                            <i className="fa fa-chevron-right"></i>
                        </a>
                    }
                </div>
            </ReactTouchEvents>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/layout/PhotoSlider/index.js